import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Fade.scss'

import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

const Fade = props =>
	<CSSTransitionGroup
		transitionName={{
			enter: styles.enter,
			enterActive: styles.enterActive,
			leave: styles.leave,
			leaveActive: styles.leaveActive,
			appear: styles.enter,
			appearActive: styles.enterActive
		}}
		transitionEnterTimeout={150}
		transitionLeaveTimeout={150}
		transitionAppearTimeout={150}
		transitionAppear={true}
		styleName="wrapper"
	>
		{props.children}
	</CSSTransitionGroup>

export default CSSModules(Fade, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Transitions/Fade.js